<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  size="medium"
  color="#00778C"
  type="line-spin-fade"
>
</ngx-spinner>
<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  size="medium"
  color="#00A8C6"
  type="ball-spin-clockwise-fade-rotating"
  name="longRequest"
>
<p>{{'Veuillez patienter' | translate}}...</p>
</ngx-spinner>